import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import { Redirect } from 'react-router-dom';
import { StyleSheet, css } from 'aphrodite';
import AppBar from '@material-ui/core/AppBar';
import Toolbar from '@material-ui/core/Toolbar';
import Typography from '@material-ui/core/Typography';
import Button from '@material-ui/core/Button';
import IconButton from '@material-ui/core/IconButton';
import MenuItem from '@material-ui/core/MenuItem';
import Menu from '@material-ui/core/Menu';

import { AppConfig } from '../AppConfig';
import { AppTheme } from '../styles/AppTheme';
import { Controller } from '../common/Controller';

export class Header extends Component {
  constructor(props) {
    super(props);
    this.state = {
      anchorEl: null,
    };
  }

  handleMenu = event => {
    this.setState({ anchorEl: event.currentTarget });
  };

  handleClose = () => {
    this.setState({ anchorEl: null });
  };

  render() {
    const appUser = Controller.get().userMgr().getAppUser()
    const { anchorEl } = this.state;
    const open = Boolean(anchorEl);
    return (
      <div>
        <AppBar className={css(Styles.appbar)} color='primary' position='fixed' elevation={0}>
          <Toolbar className={css(Styles.toolbar)}>
            <div className={css(Styles.logoContainer)}>
              <Link to={'/'}>
                <img src={require('../assets/images/logo2.png')} alt='Logo' className={css(Styles.logoImage)} />
              </Link>
            </div>

            {this.props.currentUser &&
              <div>
                <IconButton
                  aria-owns={open ? 'menu-appbar' : null}
                  aria-haspopup='true'
                  onClick={this.handleMenu}
                  color='secondary'
                >
                  <i className='material-icons' style={{fontSize: 42}}>account_circle</i>
                </IconButton>
                <Menu
                  id='menu-appbar'
                  anchorEl={anchorEl}
                  anchorOrigin={{
                    vertical: 'top',
                    horizontal: 'right',
                  }}
                  transformOrigin={{
                    vertical: 'top',
                    horizontal: 'right',
                  }}
                  open={open}
                  onClose={this.handleClose}
                >
                  <MenuItem disabled>Version {AppConfig.Version}</MenuItem>
                  {appUser &&
                    <MenuItem disabled>{appUser.email || appUser.phone}</MenuItem>
                  }
                  <MenuItem onClick={this.props.onLogoutClick}>Logout</MenuItem>
                </Menu>
              </div>
            }
          </Toolbar>
        </AppBar>
      </div>
    );
  }

}



const Styles = StyleSheet.create({
  appbar: {
    backgroundColor: 'white',
  },
  toolbar: {
    minHeight: AppTheme.toolbarHeight,
    paddingLeft: 10,
    paddingRight: 10,
  },
  logoImage: {
    height: 60
  },
  logoContainer: {
    flex: 1,
    textAlign: 'left'
  },
  headerInfo: {
    fontSize: 14,
    color: 'black',
    textAlign: 'right'
  },
  headerTelephone: {
    fontSize: 14,
    textDecoration: 'none',
    color: 'black'
  }
})



// WEBPACK FOOTER //
// ./src/components/Header.js